import { ModalBody, ModalFoot, ModalHead, Text } from '@dixa/lib-shared-habla';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';

import { VersionNameModal } from './versionNameModal';

export type ReplaceDraftModalProps = {
  /** Replaces the draft with the version, once the agent agrees to. */
  onDiscard: () => Promise<void>;
};

/**
 * There is one draft, so editing a saved version replaces it. Asked only when
 * the draft holds changes no version has.
 */
export function ReplaceDraftModal({
  onDiscard,
}: ReplaceDraftModalProps): JSX.Element {
  const { hideModal, showModal } = useModal();

  return (
    <ModalWrapper>
      <ModalHead title="Edit version" onClose={hideModal} />
      <ModalBody>
        <Text.Paragraph>
          Editing this version makes it your working draft. You can only have
          one draft at a time, so this will replace your current draft. What
          should we do with your current draft first?
        </Text.Paragraph>
      </ModalBody>
      <ModalFoot
        confirmName="Save current draft"
        confirmOnClick={() => showModal(VersionNameModal, { mode: 'create' })}
        confirmSecondaryName="Discard current draft"
        confirmSecondaryOnClick={() => {
          hideModal();
          void onDiscard();
        }}
        confirmSecondaryProps={{ variant: 'danger' }}
      />
    </ModalWrapper>
  );
}
